
import { defineComponent } from "vue";
import { Skill } from "@/components/molecules";

export default defineComponent({
  components: { Skill }
});
